<template>
	<div>
		<div class="videoContainer">
			<video class="fullscreenVideo" id="bgVid" playsinline autoplay muted loop controlsList="nodownload"
				disablePictureInPicture>
				<source src="../assets/vedio/beijingvedio.mp4" type="video/mp4">
			</video>
		</div>
		<div class="shine" style="color: aliceblue;position: absolute;z-index: 1;font-family: led;font-weight: 900;">
			激光赋能 气体感知
		</div>
		<div class="lj" style="position: absolute;z-index: 1;font-family: led;" @click="handleSelect(4)">
			了解更多
		</div>
		<div
			style="width: 100%;height: 62rem;background-color: black;position: absolute;z-index: 1;margin-top:56rem;overflow: hidden;color: white;text-align: center;">
			<el-carousel indicator-position="none" height="62rem">
				<el-carousel-item v-for="item in zmd" :key="item.path">
					<el-image :src="item.path" fit="fill"></el-image>
				</el-carousel-item>

			</el-carousel>
		</div>
		<div
			style="width: 100%;height: 50rem;background-color: black; position: absolute;z-index: 1;margin-top:118rem;overflow: hidden;">
			<div style="color: white;font-weight: 900;font-size: 3rem;margin-top: 2rem;">
				技术与应用
			</div>
			<div style="width: 85%;height: 85%;margin-left: 9rem;border-bottom: gray 0.1rem solid;">
				<div class="ad1" @click="handleSelect(3)" v-bind:style="{ 'background-image': 'url('+bj+')' }">天然气传输场站监测
				</div>
				<div class="ad2" @click="handleSelect(3)">油气田场站监测&nbsp;&nbsp;&nbsp;&nbsp;</div>
				<div class="ad3" @click="handleSelect(3)">无人值守场站监测</div>
				<div class="ad4" @click="handleSelect(3)">市区天然气管道巡检检测</div>
				<div class="ad5" @click="handleSelect(3)">无人机检测(激光、泵吸)</div>
			</div>
		</div>
		<div
			style="width: 100%;height: 10rem;background-color: black;position: absolute;z-index: 1;margin-top:168rem;overflow: hidden;text-align: center;">
			<div style="color: gray;float: left;margin-left: 46.5rem;margin-top: 1rem;">
				联系我们 : 0411-87588091&nbsp;0411-87588320&nbsp;13942048140&nbsp;<br>
				辽ICP备2023010852号-1
			</div>

			<div style="margin-left: 19rem; height: 7rem;width: 7rem;float: left;color: gray;">
				<img src="../assets/image/gongzhonghao.jpg" height="100%" width="100%" title="微信公众号">
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'First',
		props: {
			msg: String
		},
		data() {
			return {
				bj: require("../assets/image/2.png"),
				zmd: [{
						path: "http://114.116.47.165:12345/zmd1.png"
					},
					{
						path: "http://114.116.47.165:12345/zmd2.png"
					},
					{
						path: "http://114.116.47.165:12345/zmd3.png"
					},
					{
						path: "http://114.116.47.165:12345/zmd4.png"
					},
					{
						path: "http://114.116.47.165:12345/zmd5.png"
					},
					{
						path: "http://114.116.47.165:12345/zmd6.png"
					},
				]
			}
		},
		methods: {
			test() {
				this.http.get({
					url: "/pictures/list",
				}).then((data) => {
					console.log(this.bj)
					this.bj = require('../assets/' + data[0].picturePath)
					console.log(this.bj)
				})
			},
			handleSelect(key) {
				if (key == 1) {
					first.style.display = "block";
					second.style.display = "none";
					third.style.display = "none";
					fourth.style.display = "none";
				} else if (key == 2) {
					first.style.display = "none";
					second.style.display = "block";
					third.style.display = "none";
					fourth.style.display = "none";
				} else if (key == 3) {
					first.style.display = "none";
					second.style.display = "none";
					third.style.display = "block";
					fourth.style.display = "none";
				} else if (key == 4) {
					first.style.display = "none";
					second.style.display = "none";
					third.style.display = "none";
					fourth.style.display = "block";
				}
			}
		}
	}
</script>


<style>
	.videoContainer {
		position: absolute;
		width: 100%;
		height: 100%;
		overflow: hidden;
		z-index: -100;
	}

	.videoContainer:before {
		content: "";
		position: absolute;
		width: 100%;
		height: 100%;
		display: block;
		z-index: -100;
		top: 0;
		left: 0;
		background: rgba(25, 29, 34, .65);
		background-size: cover;
	}

	.fullscreenVideo {
		width: 100%;
		height: 100%;
		object-fit: fill;
		filter: blur(1px)
	}

	.shine {
		margin-left: 30rem;
		margin-top: 20rem;
		width: 60rem;
		font-size: 100px;
		text-align: center;
	}

	.lj {
		margin-left: 56.2rem;
		margin-top: 32rem;
		width: 8rem;
		height: 3rem;
		line-height: 3rem;
		font-size: 16px;
		text-align: center;
		color: white;
		border: solid;
		border-radius: 50px;
		font-weight: 500;
		cursor: pointer;
	}

	.el-carousel__item h3 {
		color: #475669;
		font-size: 18px;
		opacity: 0.75;
		line-height: 60rem;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n+1) {
		background-color: #d3dce6;
	}

	::v-deep .el-carousel__arrow {
		height: 4rem;
		width: 4rem;
		font-size: 1rem;
	}

	.ad1 {
		width: 38%;
		height: 44%;
		float: left;
		background-size: 100% 100%;
		margin-top: 1.5rem;
		margin-left: 11rem;
		margin-right: 2rem;
		margin-bottom: 1.5rem;
		border-radius: 4%;
		color: white;
		font-size: 2rem;
		line-height: 19rem;
		font-weight: 900;
		cursor: pointer;
	}

	.ad2 {
		width: 38%;
		height: 44%;
		background-image: url("../assets/image/3.png");
		float: left;
		background-size: 100% 100%;
		margin-top: 1.5rem;
		margin-bottom: 1.5rem;
		border-radius: 4%;
		color: white;
		font-size: 2rem;
		line-height: 10rem;
		font-weight: 900;
		text-align: right;
		cursor: pointer;
	}

	.ad3 {
		width: 25%;
		height: 38%;
		background-image: url("../assets/image/1.png");
		background-size: 100% 100%;
		float: left;
		border-radius: 4%;
		margin-left: 11rem;
		margin-right: 1.5rem;
		color: white;
		font-size: 2rem;
		line-height: 23rem;
		font-weight: 900;
		cursor: pointer;
	}

	.ad4 {
		width: 25%;
		height: 38%;
		background-image: url("../assets/image/4.jpg");
		float: left;
		background-size: 100% 100%;
		border-radius: 4%;
		margin-right: 1.5rem;
		color: white;
		font-size: 1.5rem;
		line-height: 24rem;
		font-weight: 900;
		cursor: pointer;
	}

	.ad5 {
		width: 25%;
		height: 38%;
		background-image: url("../assets/image/5.jpg");
		float: left;
		background-size: 100% 100%;
		border-radius: 4%;
		color: white;
		font-size: 1.5rem;
		line-height: 24rem;
		font-weight: 900;
		cursor: pointer;
	}
</style>